/*
 * Copyright (C) 2021 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export const DDialogState = {
	MODAL: "MODAL",
	MODELESS: "MODELESS",
	MENU: "MENU"
};
